'use strict';
var uncurryThis = require('../internals/function-uncurry-this');
var aCallable = require('../internals/a-callable');

module.exports = function demethodize() {
  return uncurryThis(aCallable(this));
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/internals/function-demethodize.js
// module id = lMbK
// module chunks = 0